module.exports = __webpack_public_path__ + "static/img/4489_phase_function_Paper_Points.13014b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4489_phase_function_Paper_Points.png
// module id = AwMW
// module chunks = 0